import { Component, ViewChild } from '@angular/core';
import { Register } from '../../../classes';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent extends Register {

}

